import { POSTHOG_EVENTS, POSTHOG_FEATURE_FLAGS } from '@platform-ui/providers/posthog.js';
import { usePostHog } from 'posthog-js/react';
import { useState } from 'react';
import { IIdleTimerProps, IdleTimerProvider } from 'react-idle-timer';
import InactivityDialog from '../components/InactivityDialog/index.js';
import useLogout from '../hooks/useLogout.js';

export default function UserInactivityProvider({
  children,
}: React.PropsWithChildren<IIdleTimerProps>) {
  const { logout } = useLogout();
  const posthog = usePostHog();
  const [prompt, setPrompt] = useState(false);
  const onIdle = () => {
    if (!posthog.isFeatureEnabled(POSTHOG_FEATURE_FLAGS.idleSessionTimeout)) return;
    posthog.capture(POSTHOG_EVENTS.sessionIdleTimeout);
    return logout();
  };

  const { promptTimeout, timeout } = (() => {
    try {
      const config = posthog.getFeatureFlagPayload(POSTHOG_FEATURE_FLAGS.idleSessionTimeout) as {
        timeoutMinutes: number;
        warningMinutes: number;
      };
      return {
        promptTimeout: 1000 * 60 * Number(config.warningMinutes),
        timeout: 1000 * 60 * Number(config.timeoutMinutes),
      };
    } catch (error) {
      return { promptTimeout: 1000 * 60 * 2, timeout: 1000 * 60 * 15 };
    }
  })();

  return (
    <IdleTimerProvider
      promptBeforeIdle={promptTimeout}
      timeout={timeout}
      throttle={500}
      onIdle={onIdle}
      onPrompt={() => setPrompt(true)}
    >
      <InactivityDialog prompt={prompt} setPrompt={setPrompt} />
      {children}
    </IdleTimerProvider>
  );
}
